import type { StateStore } from "../app/state/StateStore";

import { BaseBlock } from "./BaseBlock";

/**
 * Блок "Інші ваші курси".
 */
export class ContinueProductsBlock extends BaseBlock {

constructor(
    private readonly store: StateStore,
    private readonly onOpenKrok: (krokId: string) => void
) {
        super();
    }

    public override mount(): void {

        this.root =
            this.render();

    }

    public override update(): void {

        const newRoot =
            this.render();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    private render(): HTMLElement {

        const wrapper =
            document.createElement("div");

        const state =
            this.store.getState();

        if (state.primaryScreen.type !== "notice") {
            return wrapper;
        }

        const products =
            state.primaryScreen.continueProducts;

        if (!products.length) {
            return wrapper;
        }

        wrapper.className =
            "task explanation-task";

        const title =
            document.createElement("h3");

        title.textContent =
            "Інші ваші курси";

        wrapper.appendChild(title);

        for (const product of products) {

            const card =
                document.createElement("div");

            card.style.marginTop =
                "16px";

            card.style.paddingTop =
                "12px";

            card.style.borderTop =
                "1px solid #ddd";

            const productTitle =
                document.createElement("div");

            productTitle.innerHTML =
                `<b>${product.title}</b>`;

            card.appendChild(
                productTitle
            );

            if (product.noticeType === "continue_next") {

                const button =
                    document.createElement("button");

                button.textContent =
                    "Перейти";

                button.style.marginTop =
                    "10px";

                button.addEventListener(
                    "click",
                    () => {

                        if (product.nextKrokId) {

                            this.onOpenKrok(
                                product.nextKrokId
                            );

                        }

                    }
                );

                card.appendChild(
                    button
                );

            } else {

                const text =
                    document.createElement("div");

                text.textContent =
                    "Доступних нових кроків немає";

                text.style.marginTop =
                    "10px";

                card.appendChild(
                    text
                );

            }

            wrapper.appendChild(
                card
            );

        }

        return wrapper;

    }

}